import { Link } from "react-router-dom";
import { MapPin, Loader2 } from "lucide-react";
import { CoconutTree, Crab, Seashell, Starfish } from "@/components/KonkanVectors";

const V = ({ children, className }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">{children}</div>
);

const DEFAULT_IMG = "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop";

export const DestinationsGrid = ({ locations, loading }) => (
  <section className="relative py-12 md:py-16 px-6 md:px-8 bg-white overflow-hidden" data-testid="locations-section">
    <V className="-right-4 md:right-2 -top-8 w-32 md:w-52 opacity-[0.18]"><CoconutTree /></V>
    <V className="left-4 md:left-8 top-6 w-20 md:w-32 opacity-[0.20]"><Crab /></V>
    <V className="right-1/4 bottom-4 w-14 md:w-20 opacity-[0.15]"><Seashell /></V>
    <V className="left-1/3 bottom-2 w-12 md:w-16 opacity-[0.14]"><Starfish /></V>
    <div className="max-w-7xl mx-auto relative z-10">
      <div className="flex items-end justify-between mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">Popular Destinations</h2>
      </div>
      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : locations.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {locations.slice(0, 6).map((loc, i) => (
            <Link
              key={loc.id} to={`/location/${loc.slug}`}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden animate-fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`location-card-${loc.slug}`}
            >
              <img src={loc.image || DEFAULT_IMG} alt={loc.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" onError={(e) => { e.target.src = DEFAULT_IMG; }} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-base font-semibold text-white">{loc.name}</h3>
                {loc.homestay_count > 0 && <p className="text-xs text-white/75">{loc.homestay_count} Homestays</p>}
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 bg-muted/30 rounded-xl">
          <MapPin className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">No locations available yet</p>
        </div>
      )}
    </div>
  </section>
);
